import { z } from 'zod';

/**
 * Regex to detect common XSS patterns like <script> tags,
 * event handlers (onmouseover, onerror, etc.), and javascript: pseudo-protocol.
 */
const DANGEROUS_CONTENT_REGEX =
  /<script\b|on\w+\s*=|javascript:|alert\(|eval\(|expression\(/i;

export const FEEDBACK_COMMENT_MAX_LENGTH = 5000;

export const feedbackSchema = z.object({
  feedbackComments: z
    .string()
    .max(
      FEEDBACK_COMMENT_MAX_LENGTH,
      `Comment must be at most ${FEEDBACK_COMMENT_MAX_LENGTH} characters`
    )
    .refine((val) => !DANGEROUS_CONTENT_REGEX.test(val), {
      message:
        'Potentially malicious content detected. Please remove any script-like tags or code.',
    })
    .optional()
    .or(z.literal('')),
});

export type FeedbackData = z.infer<typeof feedbackSchema>;
